import type * as THREE from 'three'
import { ESPESSURA_PAINEL_TETO, larguraPainelTeto, type PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { criarCaixaArredondada, geometriaBase, type TransformacaoRepouso } from './malhaDeformavel'

/**
 * Teto deformável.
 *
 * O campo do teto (`deslocamentoTeto`) baixa a LINHA do teto — mais do lado
 * que tocou o solo, com vinco junto à longarina e sobre a coluna B — e empurra
 * o conjunto para o lado oposto, inclinando as colunas. Nada de depressão
 * central circular. Na lateral severa, só a borda do lado atingido desce.
 */
export function baseTeto(perfil: PerfilVeiculo): THREE.BufferGeometry {
  const comprimento = perfil.teto.zDianteiro - perfil.teto.zTraseiro
  return geometriaBase(`teto:${perfil.id}`, () =>
    criarCaixaArredondada(larguraPainelTeto(perfil), ESPESSURA_PAINEL_TETO, comprimento, [16, 1, 18], 0.045),
  )
}

export const repousoTeto = (perfil: PerfilVeiculo): TransformacaoRepouso => ({
  posicao: [0, perfil.tetoY, (perfil.teto.zDianteiro + perfil.teto.zTraseiro) / 2],
})
